import React, { useEffect } from "react";
import { Dialog, DialogContent, Typography, Box, Button } from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { DEFAULT_CURRENCY } from "../../../../../static/Constants";
import FiveSlotSymbolIcon from "./FiveSlotSymbolIcon";

export const FiveSlotWinModal = ({
  open,
  onClose,
  result,
  currencySymbol = DEFAULT_CURRENCY,
}) => {
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        // Auto close after 5 seconds if user hasn't clicked
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [open]);

  if (!result) return null;

  const isJackpot = result.type === "jackpot";
  const isFreeSpins = result.type === "freespins";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "24px",
          background: isJackpot
            ? "radial-gradient(circle at 50% 30%, #ef4444 0%, #7f1d1d 60%, #0f172a 100%)"
            : "radial-gradient(circle at 50% 30%, #f59e0b 0%, #b45309 60%, #0f172a 100%)",
          border: "4px solid #fde047",
          boxShadow: "0 0 50px rgba(253, 224, 71, 0.7), inset 0 0 30px rgba(255,255,255,0.4)",
          color: "#ffffff",
          textAlign: "center",
          p: 2.5,
          overflow: "hidden",
          position: "relative",
          animation: "modalPop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
          "@keyframes modalPop": {
            "0%": { transform: "scale(0.7)", opacity: 0 },
            "100%": { transform: "scale(1)", opacity: 1 },
          },
        },
      }}
    >
      <DialogContent sx={{ p: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
        {/* Glowing Trophy / Winning Icon */}
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #fef08a 0%, #eab308 100%)",
            border: "3px solid #ffffff",
            boxShadow: "0 0 25px rgba(254, 240, 138, 0.9)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 2,
            animation: "bounceTrophy 1s infinite alternate ease-in-out",
            "@keyframes bounceTrophy": {
              "0%": { transform: "translateY(0)" },
              "100%": { transform: "translateY(-8px)" },
            },
          }}
        >
          {result.symbol ? (
            <FiveSlotSymbolIcon symbol={result.symbol} size="sm" isWinning />
          ) : isJackpot ? (
            <EmojiEventsIcon sx={{ fontSize: 46, color: "#78350f" }} />
          ) : (
            <AutoAwesomeIcon sx={{ fontSize: 46, color: "#78350f" }} />
          )}
        </Box>

        <Typography
          variant="h4"
          sx={{
            fontFamily: "'Impact', 'Arial Black', sans-serif",
            fontWeight: 900,
            color: "#fef08a",
            letterSpacing: "1.5px",
            textTransform: "uppercase",
            textShadow: "0 2px 4px rgba(0,0,0,0.8), 0 0 20px #eab308",
            mb: 0.5,
          }}
        >
          {result.label || "MEGA WIN!"}
        </Typography>

        <Typography variant="body2" sx={{ color: "#fef9c3", fontWeight: 700, mb: 2 }}>
          {isFreeSpins
            ? `${result.freeSpinsWon || 5} FREE SPINS AWARDED!`
            : isJackpot
            ? "CONGRATULATIONS! 5-REEL JACKPOT PRIZE WON!"
            : "CONGRATULATIONS!"}
        </Typography>

        <Box
          sx={{
            py: 1.5,
            px: 3,
            borderRadius: "16px",
            background: "rgba(0, 0, 0, 0.5)",
            border: "2px solid #fde047",
            boxShadow: "inset 0 0 15px rgba(253, 224, 71, 0.4)",
            mb: 3,
            width: "100%",
          }}
        >
          <Typography variant="caption" sx={{ color: "#fef08a", fontWeight: 700, display: "block" }}>
            YOU WON
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontFamily: "'Impact', 'Arial Black', sans-serif",
              fontWeight: 900,
              color: "#4ade80",
              textShadow: "0 0 12px #22c55e, 0 2px 4px rgba(0,0,0,0.9)",
            }}
          >
            {currencySymbol}{" "}
            {parseFloat(result.amount || 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
        </Box>

        <Button
          fullWidth
          variant="contained"
          onClick={onClose}
          sx={{
            py: 1.2,
            borderRadius: "14px",
            background: "linear-gradient(180deg, #fef08a 0%, #eab308 50%, #b45309 100%)",
            color: "#451a03",
            fontFamily: "'Impact', 'Arial Black', sans-serif",
            fontSize: "1.2rem",
            letterSpacing: "1px",
            border: "2px solid #ffffff",
            boxShadow: "0 6px 20px rgba(0,0,0,0.6)",
            "&:hover": {
              background: "linear-gradient(180deg, #ffffff 0%, #fde047 50%, #ca8a04 100%)",
            },
          }}
        >
          COLLECT PRIZE
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default FiveSlotWinModal;
